import FooterPresentation from 'components/Footer/FooterPresentation'

export default {
  Presentation: FooterPresentation,
}
